import { RoleGroups, Roles } from '@/router/roles';

export function canViewAvailabilityAction(userRoles: readonly string[] = []): boolean {
	const roleSet = new Set(userRoles);
	return roleSet.has(Roles.OFFICIAL) || !RoleGroups.CLUB.some((role) => roleSet.has(role));
}
